import React, { useState } from "react";
import "./Excursion.css";
import ExcursionsList from "./ExcursionsList";
import SelectedExcursion from "./SelectedExcursion";

function Excursion() {
    const [selectedExcursion, setSelectedExcursion] = useState(null);

    const handleSelectedExcursion = (excursion) => {
        console.log("Selected excursion:", excursion);
        setSelectedExcursion(excursion);
    };

    return (
        <div className={`Excursion ${selectedExcursion ? "excursion-selected" : ""}`}>
            <div className="Excursion_list">
                <h2>Expéditions</h2>
                <ExcursionsList onSelectExcursion={handleSelectedExcursion} />
            </div>

            <div className="Excursion_selected">
                {selectedExcursion ? (
                    <SelectedExcursion excursion={selectedExcursion} />
                ) : (
                    <p></p>
                )}
            </div>
        </div>
    );
}

export default Excursion;